interface QasaSectionProps {
    className?: string;
    children: React.ReactNode;
}

export const QasaSection = ({ className, children }: QasaSectionProps) => (
    <section
        className={`mx-auto px-[16] md:px-[128] mt-16 py-[48] rounded-0 md:rounded-[32] ${className ?? ''}`}
        style={{ maxWidth: '1392px', backgroundColor: '#F9F9F6' }}>
        {children}
    </section>
);
